<div class=" title mb-0" mat-dialog-title>
    Contribute a new skill
    <span type="button" class="float-right" (click)="closeDialog();">
        <span aria-hidden="true" style="font-size: 37px;">&times;</span>
    </span>
</div>
<div mat-dialog-content>
    <form [formGroup]="addNewSkillForm">
        <div class="row mt-3">
            <!-- <div class="col-lg-3"><label class="attch2" matSuffix>{{'Skill Title'|translate}}</label></div> -->
            <div class="col-md-12 mb-2">
                <h6 class="text-red" style="font-size: 13px;">
                    Thank you for the contribution to skills database. Please provide the correct and primary name of
                    the skill and associated skill categories. You can also provide sub-skills or alternate names if any
                    for the skill.
                </h6>
            </div>
            <div class="col-lg-12">
                <mat-form-field floatLabel="always">
                    <mat-label>{{'Skill Name'|translate}}</mat-label>
                    <input matInput placeholder="{{'Maximum of 50 characters'|translate}}" maxlength="50"
                        formControlName="title" name="title" required />
                    <mat-error *ngIf="addNewSkillForm.get(['title']).hasError('required')">
                        {{"ERROR.field_is_mandatory"|translate}}
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-lg-12">
                <tm-multi-select [options]="skillCategoryList||[]" [form_group]="addNewSkillForm"
                    [form_control]="'skillCatCode'" [title_property]="'title'" [id_property]="'skillCatCode'"
                    float_label="always" [label]="'Skill Category' | translate"
                    [data]="addNewSkillForm.value.skillCatCode" [placeholder]="'Skill Category' | translate">
                </tm-multi-select>
            </div>
            <div class="col-lg-12">
                <mat-form-field floatLabel="always">
                    <mat-label>{{'Alternate Name(s)'|translate}}</mat-label>
                    <input matInput placeholder="{{'Enter Alternate Name'|translate}}" formControlName="altKeywords"
                        name="altKeywords" />
                </mat-form-field>
            </div>
            <div class="col-lg-12" *ngIf="false">
                <label style="font-size: 14px;
                color: rgb(5, 33, 136);" matSuffix>
                    {{'(Select one or more functions to which the skill belongs)'|translate}}
                </label>

                <!-- <tm-multi-select [options]="skillCategoryList || []" [form_group]="addNewSkillForm"
                    form_control="skillCatCode" title_property="title" id_property="skillCatCode" float_label="always"
                    [label]="'Associated Functions' | translate" [data]="addNewSkillForm.value.skillCatCode"
                    [master_obj]="skillCategoryList || []" [placeholder]="'< - - Select - - >' | translate">
                </tm-multi-select> -->
            </div>
        </div>

    </form>
</div>

<mat-dialog-actions>
    <button mat-raised-button (click)="saveSkill()" style="background-color:#22295d;color:white" class=" ml-auto"
        [disabled]="clicked">
        {{ 'Submit' | translate }}&nbsp; <mat-icon *ngIf="clicked">
        </mat-icon>
    </button>
</mat-dialog-actions>